import { createAction, props } from '@ngrx/store';
import { BDMatrixFilter } from '../../../models/bdMatrixFilter.model';
import { DictionaryPage } from '../../study-slide-outs/sections/company-drill-down/models/dictionary-page.model';

export const initItemsPerPage = createAction('[Master Matrix Component] Init Items Per Page');

export const itemsPerPageInitiated = createAction(
  '[Master Matrix Effects] Items Per Page Initiated',
  props<{ itemsPerPage: number; fetchedFromSessionStore: boolean }>()
);

export const updateItemsPerPage = createAction('[Master Matrix Component] Update Items Per Page', props<{ itemsPerPage: number }>());

export const updateItemsPerPageOptionsUserModification = createAction(
  '[Master Matrix Effects] Update Items Per Page Options User Modification',
  props<{ isUpdatedByUser: boolean }>()
);

export const sendExternalDataForDrillDown = createAction(
  '[Master Matrix Component] Send External Data For Drill Down',
  props<{ idsByPage: DictionaryPage; count: number; rows: number }>()
);

export const sendNavigationDataForDrillDown = createAction(
  '[Master Matrix Component] Send Navigation Data For Drill Down',
  props<{ page: number; index: number }>()
);

export const sendSelectedComparableIdForDrillDown = createAction(
  '[Master Matrix Component] Send Selected Comparable Id For Drill Down',
  props<{ id: number }>()
);

export const getPageDataForDrillDown = createAction(
  '[Master Matrix Component] Get Page Data For Drill Down',
  props<{ filter: BDMatrixFilter; page: number; index: number }>()
);

export const pageDataForDrillDownLoaded = createAction(
  '[Master Matrix Effects] Page Data For Drill Down Loaded',
  props<{ page: number; index: number; comparables: { comparableId: number; companyName: string; databaseId: number; bvdId: string }[] }>()
);

export const pageDataForDrillDownLoadFailed = createAction('[Master Matrix Effects] Page Data For Drill Down Load Failed');

export const pageDataLoaded = createAction(
  '[Master Matrix Component] Page Data Loaded',
  props<{ comparables: { comparableId: number; companyName: string; databaseId: number; bvdId: string }[] }>()
);
